/**
 * T.P.I. Form Fields.
 * @format
 */
import {
  countryList,
  countryParentItemsList,
} from '../../form-components/lists/country-list';
import { stateList } from '../../form-components/lists/state-list';

export const interoperabilityFormFields = [
  {
    fieldTitle: 'Please provide your contact information:',
    fieldName: 'tri-contact-info',
    type: 'markup',
    id: 'markup1',
  },
  {
    fieldTitle: 'First Name',
    fieldName: 'FirstName',
    id: 'fname',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last Name',
    fieldName: 'LastName',
    id: 'lname',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Title',
    fieldName: 'Title',
    id: 'title',
    type: 'text',
    placeholderText: 'Job title here',
    errorMessage: 'Title field required.',
    required: true,
    useNameAsLookupValue: true,
  },
  {
    fieldTitle: 'Company',
    fieldName: 'Company',
    id: 'organization',
    type: 'text',
    placeholderText: "Your Company's name",
    errorMessage: 'Company field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Address',
    fieldName: 'Address',
    id: 'address',
    type: 'text',
    placeholderText: "Your Company's address",
    errorMessage: 'Address field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'City',
    fieldName: 'City',
    id: 'city',
    type: 'text',
    placeholderText: "Your Company's city",
    errorMessage: 'City field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Postal Code',
    fieldName: 'PostalCode',
    id: 'postal-code',
    type: 'text',
    placeholderText: "Your Company's postal code",
    errorMessage: 'Postal Code field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
    dependentField: true,
  },
  {
    fieldTitle: 'Country',
    fieldName: 'Country',
    id: 'country-select',
    type: 'select',
    placeholderText: 'Select a country',
    errorMessage: 'Country field required.',
    required: true,
    list: countryList,
    useNameAsLookupValue: true,
    parentItems: countryParentItemsList,
    dependencyId: 'state-select',
  },
  {
    fieldTitle: 'State or province',
    fieldName: 'State',
    id: 'state-select',
    type: 'select',
    placeholderText: 'Select a state or province',
    errorMessage: 'State or province field required.',
    required: true,
    list: stateList,
    useNameAsLookupValue: true,
    dependentField: true,
  },
  {
    fieldTitle: 'Phone number',
    fieldName: 'Phone',
    id: 'phone',
    type: 'text',
    placeholderText: "Your Company's phone number",
    errorMessage: 'Phone Number field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Website URL',
    fieldName: 'Website',
    id: 'website',
    type: 'text',
    placeholderText: "Your Company's website URL",
    errorMessage: 'Website URL field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Please tell us about your company:',
    fieldName: 'tri-company-info',
    type: 'markup',
    id: 'markup2',
  },
  {
    fieldTitle: 'Headquarters Location',
    fieldName: 'Headquarters-Location',
    id: 'hqlocation',
    type: 'textarea',
    textRows: 3,
    placeholderText: "Your Company's Headquarters Location",
    errorMessage: 'Headquarters Location field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Number of Employees',
    fieldName: 'Number-of-Employees',
    id: 'number-of-emp',
    type: 'text',
    placeholderText: '',
    errorMessage: 'Number of Employees field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Years in Business',
    fieldName: 'Years-in-Business',
    id: 'year-in-bus',
    type: 'text',
    placeholderText: '',
    errorMessage: 'Years in Business field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Primary Competitors',
    fieldName: 'Primary-Competitors',
    id: 'prim-competitor',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Primary Competitors field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'With which other vendors do you currently work/support?',
    fieldName: 'With-which-other-vendors-do-you-currently-work-support',
    id: 'vendor-support',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Vendor support field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Please tell us about your product offering:',
    fieldName: 'tri-product-info',
    type: 'markup',
    id: 'markup3',
  },
  {
    fieldTitle: 'What is the intended use for your product?',
    fieldName: 'What-is-the-intended-use-for-your-product',
    id: 'intend-prod-use',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Intended Use field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle:
      "With which of Varian's products do you anticipate your product to interface and/or integrate?",
    fieldName:
      'With-which-of-Varian-s-products-do-you-anticipate-your-product-to-interface',
    id: 'product-to-interface',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Product to Interface field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle:
      'What are the key capabilities features/benefits of your product?',
    fieldName:
      'What-are-the-key-capabilities-features-benefits-of-your-product',
    id: 'key-capabilities',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Key Capabilities field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'How does your product differentiate from your competitors?',
    fieldName: 'How-does-your-product-differentiate-from-your-competitors',
    id: 'product-differentiate',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Product Differentiate field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle:
      'Does your device needs patient, treatment data, etc. from Varian products?',
    fieldName:
      'Does-your-device-needs-patient-treatment-data-from-Varian-products',
    id: 'device-needs-patient',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Device Needs Patient field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Please describe the patient/user workflow',
    fieldName: 'Please-describe-the-patient-user-workflow',
    id: 'user-workflow',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'user workflow field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'How many clinical sites are using your product?',
    fieldName: 'How-many-clinical-sites-are-using-your-product',
    id: 'clinical-sites',
    type: 'text',
    placeholderText: '',
    errorMessage: 'How many clinical sites field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'CE Marking; 510K review and RoHS compliance:',
    fieldName: 'tri-510k-info',
    type: 'markup',
    id: 'markup4',
  },
  {
    fieldTitle: 'Does your product have 510K clearance?',
    fieldName: 'Does-your-product-have-510K-clearance',
    id: 'product-have-510',
    type: 'select',
    placeholderText: 'Select option',
    errorMessage: 'Product have 510K field required.',
    required: true,
    list: [
      { name: 'Yes', value: 'yes' },
      { name: 'No', value: 'no' },
    ],
    useNameAsLookupValue: true,
    dependentField: false,
  },
  {
    fieldTitle: 'Does your product have CE Mark?',
    fieldName: 'Does-your-product-have-CE-Mark',
    id: 'have-ce-mark',
    type: 'select',
    placeholderText: 'Select option',
    errorMessage: 'Have CE Mark field required.',
    required: true,
    list: [
      { name: 'Yes', value: 'yes' },
      { name: 'No', value: 'no' },
    ],
    useNameAsLookupValue: true,
    dependentField: false,
  },
  {
    fieldTitle: 'Is your product RoHS compliant?',
    fieldName: 'Is-your-product-RoHS-compliant',
    id: 'rohs-compliant',
    type: 'select',
    placeholderText: 'Select option',
    errorMessage: 'RoHS compliant field required.',
    required: true,
    list: [
      { name: 'Yes', value: 'yes' },
      { name: 'No', value: 'no' },
    ],
    useNameAsLookupValue: true,
    dependentField: false,
  },
  {
    fieldTitle:
      'If the answer to any of the above is no, what are your company plans to comply?',
    fieldName:
      'If-you-answered-no-to-any-of-the-above-what-are-your-plans-to-comply',
    id: 'plans-to-comply',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Plans to Comply field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle:
      'Please describe our customer and product relationship benefits:',
    fieldName: 'tri-relationship-info',
    type: 'markup',
    id: 'markup5',
  },
  {
    fieldTitle: 'Describe the benefits of your product(s) for a Varian user',
    fieldName: 'Describe-the-benefits-of-your-product-for-Varian-user',
    id: 'describe-benefits-1',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Describe the benefits field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle:
      'Describe the benefits to Varian for considering your product(s)',
    fieldName: 'Describe-the-benefits-to-Varian-for-considering-your-product',
    id: 'describe-benefits-2',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Describe the benefits field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },

  {
    fieldTitle:
      'Please describe your software integration goals (if applicable):',
    fieldName: 'tri-software-info',
    type: 'markup',
    id: 'markup6',
  },
  {
    fieldTitle:
      'Is the intent to connect standards based only integration (HL7, DICOM, DICOM Worklist)?',
    fieldName: 'Is-the-intent-to-connect-standards-based-only-integration',
    id: 'connect-standards-based',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: '',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle:
      'Is the intent to connect using proprietary interfaces and/or APIs (Eclipse Scripting API, ARIA Services)?',
    fieldName: 'Is-the-intent-to-connect-using-proprietary-modals',
    id: 'connect-using-proprietary',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: '',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Do you want to directly access the ARIA database using SQL?',
    fieldName: 'Do-you-want-to-directly-access',
    id: 'want-to-directly-access',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: '',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Additional Comments',
    fieldName: 'mktoCommentCapture',
    id: 'comments',
    type: 'textarea',
    textRows: 3,
    placeholderText: '',
    errorMessage: 'Additional Comments field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
];
